import { useSelector } from 'react-redux'

import { Alert } from '@mui/material'
import Collapse from '@mui/material/Collapse'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'

import FadeAnimationDiv from 'components/common/Animations'
import { RootState } from 'redux/store'
import { useTheme } from 'themes'

import { newFormThemeOverrides } from '../styles'

const AlertSuccessComponent = () => {
    const { formTheme } = useTheme({ formTheme: newFormThemeOverrides })

    const { successAlertText, successAlert } = useSelector((state: RootState) => state.alert)

    return (
        <FadeAnimationDiv>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={formTheme}>
                    <Collapse in={successAlert} timeout={500}>
                        <Alert icon={false} className="success">
                            <div className="message">
                                <span className="text">{successAlertText}</span>
                            </div>
                        </Alert>
                    </Collapse>
                </ThemeProvider>
            </StyledEngineProvider>
        </FadeAnimationDiv>
    )
}

export default AlertSuccessComponent
